import { bindConnect } from '../../../utils';
import { didRegistrationConfirm } from '../../../redux/actions/auth';
import RegistrationConfirm from './RegistrationConfirm';
import * as notificationActions from '../../../redux/actions/notifications';

export default bindConnect(() => ({}), {
  notification: notificationActions.add,
  didRegistrationConfirm: didRegistrationConfirm
})(RegistrationConfirm);
